module App {
    export interface IMissingTranslationFactory extends angular.IServiceProvider {
        getMissingTranslation(key: string): void;
    }
}